import * as L from "leaflet";
import { useContext } from "react";
import { Marker } from "react-leaflet";
import { MarkerModalContext } from "../context/MarkerModal";

const Markers = ({ markers, activeLayer }) => {
  const { setShowModal, setActiveMarker } = useContext(MarkerModalContext);
  return (
    <>
      {markers.map((marker, markerIndex) => {
        if (marker.layer !== activeLayer.name) return null;
        const iconUrl = require(`../assets/images/markers/${marker.icon}.svg`)
          .default;
        return (
          <Marker
            key={markerIndex}
            position={marker.position}
            icon={
              new L.Icon({
                iconUrl,
                iconAnchor: [40, 40],
                iconSize: [80, 80],
              })
            }
            eventHandlers={{
              click: () => {
                setActiveMarker(markerIndex);
                setShowModal(true);
              },
            }}
          />
        );
      })}
    </>
  );
};

export default Markers;
